import emailjs from '@emailjs/browser';
import { db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';

/**
 * Sends a notification email for a new lead.
 * Fetches the recipient email from Admin Settings (Firestore).
 * 
 * @param {Object} leadData - The form data (name, email, phone, company, message)
 * @returns {Promise<boolean>} - True if successful, false otherwise
 */
export const sendLeadNotification = async (leadData) => {
    try {
        // 1. Fetch Credentials & Settings from Firestore
        const settingsRef = doc(db, 'settings', 'general');
        const credentialsRef = doc(db, 'settings', 'emailService');

        const [settingsSnap, credentialsSnap] = await Promise.all([
            getDoc(settingsRef),
            getDoc(credentialsRef)
        ]);

        // Credential Logic
        let serviceId = '';
        let templateId = '';
        let publicKey = '';

        if (credentialsSnap.exists()) {
            const data = credentialsSnap.data();
            serviceId = data.serviceId;
            templateId = data.templateId;
            publicKey = data.publicKey;
        }

        if (!serviceId || !templateId || !publicKey) {
            console.warn('EmailJS Credentials missing in Admin > Email Server. Email not sent.');
            return false;
        }

        // Recipient Logic
        let recipientEmail = 'info@bpoconsultants.ph'; // Default fallback
        if (settingsSnap.exists()) {
            const settings = settingsSnap.data();
            if (settings.leadNotificationEmail) {
                recipientEmail = settings.leadNotificationEmail;
            }
        }

        console.log(`Sending email to ${recipientEmail} using Service: ${serviceId}`);

        // 2. Prepare Template Parameters
        const templateParams = {
            to_email: recipientEmail,
            from_name: leadData.name,
            from_email: leadData.email,
            company: leadData.company || 'N/A',
            phone: leadData.phone || 'N/A',
            message: leadData.message,
            source: leadData.source || 'Contact Form'
        };

        // 3. Send Email
        const response = await emailjs.send(
            serviceId,
            templateId,
            templateParams,
            publicKey
        );

        console.log('Email sent successfully!', response.status, response.text);
        return true;
    } catch (error) {
        console.error('Failed to send email:', error);
        return false;
    }
};
